<style scpoed>
 .patch-action-property {
   height: 182px;
 }
 .patch-no-name-area-child-01 {
   width: 100%;
 }
</style>
<template>
  <div>
    <v-card class="patch-action-property justify-align-center">
      <v-card-text>
        <div class="patch-no-name-area-child-01 justify-align-center pb-5">
          <v-btn
              text
              color="blue darken-1"
              v-on:click="openDeviceCommunication"
              class="ma-2"
          >
            <v-icon>mdi-midi-port</v-icon> &nbsp; Port & Patch
          </v-btn>
        </div>
        <div class="patch-no-name-area-child-01 justify-align-center">
          <v-menu
              offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  color="red lighten-1"
                  elevation="2"
                  :disabled="patch_param.isSynced"
                  v-bind="attrs"
                  v-on="on"
                  class="mx-2 white--text"
              >
                <v-icon>mdi-cog</v-icon>
                &nbsp; action
              </v-btn>
            </template>
            <v-list>
              <!-- -->
              <v-list-item key="sync">
                <v-list-item-title>
                  <v-btn
                      rounded
                      text
                      :color="sync_menus.sync.color"
                      v-on:click="onIsSyncedMenuClicked(`${sync_menus.sync.action}`)"
                  ><v-icon>{{`${sync_menus.sync.iconText}`}}</v-icon>&nbsp;{{ sync_menus.sync.title }}</v-btn>
                </v-list-item-title>
              </v-list-item>
              <!-- -->

              <!-- -->
              <v-list-item key="discard">
                <v-list-item-title>
                  <v-btn
                      rounded
                      text
                      :color="sync_menus.discard.color"
                      v-on:click="onIsSyncedMenuClicked(`${sync_menus.discard.action}`)"
                  ><v-icon>{{`${sync_menus.discard.iconText}`}}</v-icon>&nbsp;{{ sync_menus.discard.title }}</v-btn>
                </v-list-item-title>
              </v-list-item>
              <!-- -->

            </v-list>
          </v-menu>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
 export default {
   name: 'PatchAction',
   props: [],
   data: () => ({
     sync_menus: {
       sync: {
         title: 'Sync to Device',
         iconText: 'mdi-camera-flip',
         color: 'primary',
         action: 'syncToDevice',
       },
       discard: {
         title: 'Discard Change',
         iconText: 'mdi-file-undo',
         color: 'red accent-2',
         action: 'discardChange',
       },
     },
     patch_param: {
       isSynced: true
     },
   }),
   watch: {
   },
   computed: {
     /*
     syncToDeviceBtnDisabled: {
       get: function() {
         return !this.$store.getters.getIsValidationOK()
       }
     }
     */
   },
   methods: {
     openDeviceCommunication: function() {
       this.$router.app.$children[0].openDeviceCommunicationApp(true)
     },
     updateParamIsSynced: function() {
       const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       const isSynced = this.$store.getters.getCheckOneEditPatchIsSynced(workingPatch_idx)
       this.$set(this.$data.patch_param, 'isSynced', isSynced)
       console.log(`[PatchAction.vue] isSynced=[${isSynced}]`)
     },
     onIsSyncedMenuClicked(action=null) {
       if (action==null) return
       switch(action) {
         case 'syncToDevice':
           this._onSyncParamEditOnePatchToDevice()
           break
         case'discardChange':
           this._onDiscardChange()
           break
       }
     },
     _onSyncParamEditOnePatchToDevice() {
       this.$router.app.$children[0].syncParamEditOnePatchToDeviceApp()
     },
     _onDiscardChange() {
       this.$router.app.$children[0].discardParamEditOnePatchApp()
     }
   },
 }
</script>
